var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("redeem_confirm_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('redeem_confirm_page.form_desc'))
    }
  }), _c('div', [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading ? _c('div', [_c('div', {
    staticClass: "p-4 shadow-lg rounded redeem--content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('redeem_confirm_page.content'))
    }
  })]) : _vm._e()], 1), _vm.getModuleConfig('redeem_confirm_page.button_text') || _vm.getModuleConfig('redeem_confirm_page.cancel_button_text') ? _c('div', {
    staticClass: "p-3 fixed-bottom bg-white footer"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary mb-2",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'LiffCouponListRedeemSuccess'
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.getModuleConfig("redeem_confirm_page.button_text")))]), _c('SharedButton', {
    staticClass: "s-btn-outline-primary",
    attrs: {
      "variant": "outline-dark"
    }
  }, [_vm._v(_vm._s(_vm.getModuleConfig("redeem_confirm_page.cancel_button_text")))])], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }